import React from "react";

var img1 = require("./../../images/background/bg-6.png");
var img2 = require("./../../images/background/line.png");

class AboutSummary extends React.Component {
  componentDidMount() {
    function loadScript(src) {
      return new Promise(function (resolve, reject) {
        var script = document.createElement("script");
        script.src = src;
        script.addEventListener("load", function () {
          resolve();
        });
        script.addEventListener("error", function (e) {
          reject(e);
        });
        document.body.appendChild(script);
        document.body.removeChild(script);
      });
    }

    loadScript("./assets/js/masonary.js");
  }
  render() {
    return (
      <>
        <div
          className="section-full p-t80 p-b80 bg-dark bg-repeat square_shape2 inner-page-padding"
          style={{ backgroundImage: "url(" + img1 + ")" }}
        >
          <div className="container">
            {/* TITLE START */}
            <div className="section-head">
              <div className="mt-separator-outer separator-left">
                <div className="mt-separator text-white">
                  <h2 className="text-uppercase sep-line-one ">
                    <span className="font-weight-300 text-primary">About</span>{" "}
                    Summary
                  </h2>
                </div>
              </div>
            </div>
            {/* TITLE END */}
            <div className="section-content our-story">
              <div className="row">
                <div className="col-md-4 col-sm-6">
                  <div className="our-story-pic-block">
                    <div className="mt-media our-story-pic">
                      <img src={require("./../../images/about/1.png")} alt="" />
                    </div>
                  </div>
                </div>
                <div className="col-md-8 col-sm-6">
                  <div
                    className="mt-box our-story-detail bg-moving bg-cover"
                    style={{ backgroundImage: "url(" + img2 + ")" }}
                  >
                    <h4 className="text-uppercase m-b20">2023-24</h4>
                    <h4 className="m-b20">Launch of JIT Services</h4>
                    <p>
                      JIT began its journey by offering essential on-demand
                      services designed to simplify everyday tasks. With a focus
                      on speed, reliability, and accessibility, we introduced
                      our first solutions for e-commerce supply and
                      quick-response support.
                    </p>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-4 col-sm-6">
                  <div className="our-story-pic-block">
                    <div className="mt-media our-story-pic">
                      <img src={require("./../../images/about/2.png")} alt="" />
                    </div>
                  </div>
                </div>
                <div className="col-md-8 col-sm-6">
                  <div
                    className="mt-box our-story-detail bg-moving bg-cover"
                    style={{ backgroundImage: "url(" + img2 + ")" }}
                  >
                    <h4 className="text-uppercase m-b20">2024</h4>
                    <h4 className="m-b20">Expansion Into Labour Services</h4>
                    <p>
                      To meet growing demand, JIT introduced skilled and
                      unskilled labour support for households, businesses, and
                      on-site operational needs. This addition strengthened our
                      commitment to delivering timely and dependable manpower
                      solutions.
                    </p>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-4 col-sm-6">
                  <div className="our-story-pic-block">
                    <div className="mt-media our-story-pic">
                      <img src={require("./../../images/about/3.png")} alt="" />
                    </div>
                  </div>
                </div>
                <div className="col-md-8 col-sm-6">
                  <div
                    className="mt-box our-story-detail bg-moving bg-cover"
                    style={{ backgroundImage: "url(" + img2 + ")" }}
                  >
                    <h4 className="text-uppercase m-b20">2024–25</h4>
                    <h4 className="m-b20">
                      Apartment Maintenance Services Launched
                    </h4>
                    <p>
                      JIT expanded its service offerings by introducing
                      apartment maintenance solutions, including plumbing,
                      electrical work, and general repairs—providing quick,
                      reliable support for residents and property owners.
                    </p>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-4 col-sm-6">
                  <div className="our-story-pic-block">
                    <div className="mt-media our-story-pic">
                      <img src={require("./../../images/about/4.png")} alt="" />
                    </div>
                  </div>
                </div>
                <div className="col-md-8 col-sm-6">
                  <div
                    className="mt-box our-story-detail bg-moving bg-cover"
                    style={{ backgroundImage: "url(" + img2 + ")" }}
                  >
                    <h4 className="text-uppercase m-b20">2025</h4>
                    <h4 className="m-b20">Unified Service Platform Rollout</h4>
                    <p>
                      JIT integrated all services — Supplies, Labour, Rentals,
                      and More — into one unified platform. This update improved
                      user experience, ensured faster delivery, and strengthened
                      our promise of “Just In Time” service.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default AboutSummary;
